import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Markdown from 'react-markdown';

import { Button, BUTTON_TYPE, BUTTON_SIZE } from '../Button';
import InfoCircleIcon from '../../images/info-circle-icon.svg';
import Drawer from '../Mui/Drawer';
import { isMobile, SIZE_XS, SIZE_SM } from '../../../../hooks/useBreakPoint';

import './InfoButton.scss';

const InfoButton = ({
  info,
}) => {
  const isMobileSize = isMobile([SIZE_XS, SIZE_SM]);

  const [show, setShow] = useState(false);

  if (!info) {
    return null;
  }

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={isMobileSize ? (
          <div />
        ) : (
          <Tooltip>
            <Markdown className="InfoButton__markdown">
              {info}
            </Markdown>
          </Tooltip>
        )}
      >
        <button
          type="button"
          className="InfoButton"
          onClick={() => setShow(isMobileSize)}
        >
          <img src={InfoCircleIcon} alt="info" />
        </button>
      </OverlayTrigger>
      {show && (
        <Drawer
          open
          anchor="bottom"
          onClose={() => setShow(false)}
        >
          <div className="InfoButton__drawer">
            <Markdown className="InfoButton__markdown">
              {info}
            </Markdown>
            <Button
              type={BUTTON_TYPE.QUATERNARY}
              size={BUTTON_SIZE.LARGE}
              onClick={() => setShow(false)}
            >
              Got it
            </Button>
          </div>
        </Drawer>
      )}
    </>
  );
};

export default InfoButton;
